import { Button as ChakraButton } from '@chakra-ui/react';
import { ButtonProps } from './buttons.types';

const getColorStyles = (colorScheme: string) => {
  const colors = colorScheme === 'black'
    ? { bg: 'black', color: 'white', hover: 'blackAlpha.700', active: 'blackAlpha.800' }
    : { bg: `${colorScheme}.400`, color: 'white', hover: `${colorScheme}.600`, active: `${colorScheme}.700` };

  return {
    bg: colors.bg,
    color: colors.color,
    _hover: { background: colors.hover },
    _active: { background: colors.active }
  };
};

export function PrimaryButton({
  colorScheme = 'blue',
  ...props
}: ButtonProps) {
  const colorStyles = getColorStyles(colorScheme);

  return (
    <ChakraButton
      variant="primary"
      {...colorStyles}
      {...props}
    />
  );
}